import { Button } from '@dealstack/frontend/shared/components/fundament/Button/Button';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { TermsAndPolicy } from '@dealstack/frontend/shared/components/TermsAndPolicy/TermsAndPolicy';
import { useTranslationAuth } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

interface Props {
	className?: string;
	children?: React.ReactNode;
	isInvestorApp?: boolean;
}

const AuthLayoutDesktop = ({ className, isInvestorApp, children }: Props) => {
	const tAuth = useTranslationAuth();
	return (
		<div className={className}>
			<AuthHeader>
				<Link to="/auth">
					<HeaderLogo variant="dealstack-logo-full" />
				</Link>
				{!isInvestorApp && (
					<a href="mailto:info@dealstack.io">
						<Button
							iconSize="lg"
							icon="chevron-right"
							iconPlacement="right"
							variant="outlined"
						>
							{tAuth('login.request_access_button')}
						</Button>
					</a>
				)}
			</AuthHeader>
			<ContentWrapper>{children}</ContentWrapper>
			<TermsAndPolicy isInvestorApp={isInvestorApp} />
		</div>
	);
};

const HeaderLogo = styled(Icon)`
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	&.svg {
		width: 12rem;
		height: fit-content;
	}
`;
const AuthHeader = styled.div`
	position: relative;
	display: flex;
	justify-content: end;
`;

const ContentWrapper = styled.div`
	align-self: center;
	margin-bottom: 5rem;
`;

const Memoized = memo(AuthLayoutDesktop);
const Styled = styled(Memoized)`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	position: relative;
	overflow-y: auto;
	overflow-x: hidden;
	width: 100vw;
	height: 100vh;
	background-color: ${({ theme }) => theme.v2.color.neutral[200]};

	${AuthHeader}, ${TermsAndPolicy}, ${ContentWrapper} {
		z-index: 1;
	}
	${AuthHeader} {
		padding: ${(props) => (props.isInvestorApp ? '2rem' : '1rem')};
	}

	${TermsAndPolicy} {
		padding: 1rem;
	}
`;

export { Styled as AuthLayoutDesktop };
